import { useQuery } from 'react-query';

import { QueryKeys } from '.';
import { useApi } from '../../context';
import { Guid, DealDebtSchedule } from '../../models';

import { AxiosUtils } from '../../utils';
import { CerebroApiEndpoints } from '../../utils/api';

export function useDebtScheduleQuery(dealGuid: Guid | undefined) {
	const api = useApi();

	return useQuery(QueryKeys.DebtSchedule(dealGuid), () =>
		AxiosUtils.getResponseData(api.get<DealDebtSchedule[]>(CerebroApiEndpoints.DebtSchedules.Root(dealGuid)))
	);
}
